import { render } from "./HealthItServices.vue?vue&type=template&id=4442b442&scoped=true&ts=true"
import script from "./HealthItServices.vue?vue&type=script&lang=ts"
export * from "./HealthItServices.vue?vue&type=script&lang=ts"

import "./HealthItServices.vue?vue&type=style&index=0&id=4442b442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4442b442"]])

export default __exports__